import { FirebaseError } from "firebase/app";
import { useAuth } from "../context/authContext";
import Icon from "./Icon";
import Apple from "./icons/apple.svg?react";
import Google from "./icons/google.svg?react";
import styles from "./SocialIdentityProviders.module.css";

interface Props {
  onSuccess: () => void;
}

const SocialIdentityProviders = ({ onSuccess }: Props) => {
  const auth = useAuth();

  return (
    <div className={styles.socialProviders}>
      <SocialIdentityProvider
        provider="google"
        onClick={() => {
          auth
            .signInWithGoogle()
            .then(() => onSuccess())
            .catch((err: FirebaseError) => {
              console.log("TODO", err);
            });
        }}
      />
    </div>
  );
};

interface SocialIdentityProviderProps {
  provider: "google" | "apple";
  onClick: () => void;
}

const SocialIdentityProvider = ({
  provider,
  onClick,
}: SocialIdentityProviderProps) => {
  const getGlyph = () => {
    switch (provider) {
      case "apple":
        return Apple;
      case "google":
        return Google;
    }
  };

  const getText = () => {
    switch (provider) {
      case "apple":
        return "Continue with Apple";
      case "google":
        return "Continue with Google";
    }
  };

  return (
    <div className={styles.socialProvider} onClick={onClick}>
      <Icon className={styles.icon} glyph={getGlyph()} />
      <span className={styles.text}>{getText()}</span>
    </div>
  );
};

export default SocialIdentityProviders;
